<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
-->
<!-- IP-NOTICE: MIXED -->
<mat-toolbar color="primary" class="mat-elevation-z4">
	<div class="header-row flex-layout-row flex-layout-align-space-between-center">
		<div class="flex-layout-row flex-layout-align-left-center flex-layout-gap-20px">
			<button mat-icon-button (click)="toggleMenu()" *ngIf="this.usersService.userPermissions.action.menu.available"
				aria-controls="main-navigation" [attr.aria-expanded]="menuOpen" aria-label="Toggle side menu">
				<mat-icon title="Toggle Side Menu">menu</mat-icon>
			</button>
			<a [routerLink]="['']"><img src="/assets/images/inverselogo.svg" height="40" alt="Logo" /></a>
		</div>

		<div class="flex-layout-row flex-layout-align-left-center flex-layout-gap-10px">
			<button *ngIf="showKioskLink" class="anchor-button load-kiosk-button" mat-raised-button (click)="loadKiosk()">Load Kiosk</button>
			<div class="username">{{ loggedInFullName }}</div>
			<button mat-icon-button [matMenuTriggerFor]="appMenu" id="account-menu-button">
				<mat-icon title="Load User Menu">account_circle</mat-icon>
			</button>
			<mat-menu #appMenu="matMenu">
				<button mat-menu-item *ngIf="showResetPassword" (click)="resetPassword()">Reset Password</button>
				<button mat-menu-item (click)="logout()">Sign out</button>
			</mat-menu>
		</div>
	</div>
</mat-toolbar>
